














import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Alert extends Vue {
  isVisible = false;
  ALERT_TIMEOUT = 6000;

  get message(): string {
    return this.$store.state.alert.message;
  }

  @Watch('message')
  onMessageChanged(val: string) {
    if (val) {
      this.isVisible = true;
      setTimeout(() => this.resetAlert(), this.ALERT_TIMEOUT);
    }
  }

  resetAlert(): void {
    this.$store.dispatch('SET_ALERT_MESSAGE', '');
    this.isVisible = false;
  }
}
